// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"90673013","111":"1a8c2a9c","382":"85809808","453":"84f276d5","577":"89431c9c","581":"6a51d74a","645":"fd8a8f0c","648":"cb1fb354","678":"4ed0c1cc","686":"6b21fd1c","827":"f4cdd393","969":"19451575"}[chunkId] + ".chunk.js";
};